// App.js - 主入口文件（精简版）
// 只负责路由逻辑，具体组件从 components 文件夹导入

import React, { useState } from 'react';
import { theme } from './theme';
import { AuthProvider, useAuth } from './AuthContext';

// 页面组件
import { LandingPage } from './components/LandingPage';
import { PricingPage } from './components/PricingPage';
import { SuccessPage } from './components/UIComponents';
import { TermsPage } from './components/TermsPage';
import { DisclaimerPage } from './components/DisclaimerPage';
import { FeedbackPage } from './components/FeedbackPage';

// 这两个页面太长，暂时保留在这个文件里
// 之后可以继续拆分
import { FullAnalysisPage } from './components/FullAnalysisPage';
import { PortfolioReviewPage } from './components/PortfolioReviewPage';
import { MyMarketSense } from './components/MyMarketSense';
import { DeepCheck } from './components/DeepCheck';


export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

function AppContent() {
  const [page, setPage] = useState('landing');
  const [selectedTicker, setSelectedTicker] = useState('AAPL');
  const [scrollToPrediction, setScrollToPrediction] = useState(false);
  const { loading } = useAuth();

  // 检查 Stripe 回调
  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('session_id')) {
      setPage('success');
      window.history.replaceState({}, '', '/');
    }
    if (urlParams.get('page') === 'deepcheck') {
      setPage('deepcheck');
      window.history.replaceState({}, '', '/');
    }
  }, []);

  // Loading 状态
  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        background: theme.bg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          width: '50px',
          height: '50px',
          border: '3px solid ' + theme.border,
          borderTop: '3px solid ' + theme.teal,
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  // 页面路由
  if (page === 'success') {
    return <SuccessPage onBack={() => setPage('landing')} />;
  }

  if (page === 'pricing') {
    return <PricingPage onBack={() => setPage('landing')} />;
  }

  if (page === 'analysis') {
    return (
      <FullAnalysisPage
        ticker={selectedTicker}
        scrollToPrediction={scrollToPrediction}
        onBack={() => { setScrollToPrediction(false); setPage('landing'); }}
        onPortfolio={() => setPage('portfolio')}
        onFeedback={() => setPage('feedback')}
        onMarketSense={() => setPage('marketsense')}
        onPricing={() => setPage('pricing')}
      />
    );
  }

  if (page === 'portfolio') {
    return (
      <PortfolioReviewPage
        onBack={() => setPage('landing')}
        onUpgrade={() => setPage('pricing')}
        onAnalysis={() => setPage('analysis')}
        onFeedback={() => setPage('feedback')}
      />
    );
  }

  if (page === 'terms') {
    return <TermsPage onBack={() => setPage('landing')} />;
  }

  if (page === 'disclaimer') {
    return <DisclaimerPage onBack={() => setPage('landing')} />;
  }

  if (page === 'marketsense') {
    return <MyMarketSense onBack={() => setPage('landing')} />;
  }

  if (page === 'feedback') {
    return <FeedbackPage onBack={() => setPage('landing')} fromPage="menu" />;
  }

  if (page === 'deepcheck') {
    return <DeepCheck onBack={() => setPage('landing')} />;
  }

  // 默认：首页
  return (
    <LandingPage
      onUpgrade={(t, opts) => {
        setSelectedTicker(t);
        setScrollToPrediction(opts?.scrollToPrediction || false);
        setPage('analysis');
      }}
      onPricing={() => setPage('pricing')}
      onPortfolio={() => setPage('portfolio')}
      onTerms={() => setPage('terms')}
      onDisclaimer={() => setPage('disclaimer')}
      onFeedback={() => setPage('feedback')}
      onMarketSense={() => setPage('marketsense')}
    />
  );
}